import React, { useEffect, useState, useRef } from 'react';
import NavBar from '../../components/NavBar';
import { RiFileExcel2Line } from 'react-icons/ri';
import { FaCheck } from 'react-icons/fa';

import Footer from '../../components/Footer';
import {
	requestNewUnits,
	requestListNotes,
	requestNotesByInv,
	requestAllInvestigations,
	requestExcelExport,
	requestDelayNotes,
} from '../../services/requests';
import Relogio from '../../images/NotifyAvaliationImages/relogio.png';
import Lupa from '../../images/NotifyAvaliationImages/lupa.png';
import Check from '../../images/NotifyAvaliationImages/check.png';
import { LuClipboardCheck } from 'react-icons/lu';
import { FaSortAlphaDown } from 'react-icons/fa';
import { FaSearch } from 'react-icons/fa';
import { IoMdEye } from 'react-icons/io';
import { FaFilter } from 'react-icons/fa';
import { GoDotFill } from 'react-icons/go';
import Json from '../../utils/tipos_incidentes.json';
import { useNavigate } from 'react-router-dom';
import Loading from '../../components/Loading';
import { HiOutlinePencilSquare } from 'react-icons/hi2';
import ClassInvForm from '../../components/ClassInvForm';
import Cookies from 'js-cookie';
import { set } from 'react-hook-form';
import { MdTurnedIn } from 'react-icons/md';

function NotesAvaliation() {
	const navigate = useNavigate();
	const [notes, setNotes] = useState([]);
	const [filters, setFilters] = useState([]);
	const [excelToken, setExcelToken] = useState('');
	const [allNotes, setAllNotes] = useState([]);
	const [currentFilter, setCurrentFilter] = useState([]);
	const [invFilter, setInvFilter] = useState(false);
	const [protocolFilter, setProtocolFilter] = useState('');
	const [duality, setDuality] = useState(false);
	const [loading, setLoading] = useState(true);
	const [unitList, setUnitList] = useState(false);
	const [listUnits, setListUnits] = useState([]);
	const [listLoading, setListLoading] = useState(false);
	const [choseStatus, setChoseStatus] = useState(false);
	const [userPermissions, setUserPermissions] = useState([]);
	const [propNotes, setPropNotes] = useState([]);
	const [propCard, setPropCard] = useState({});
	const [notifyNumbers, setNotifyNumbers] = useState();
	const [excelAlert, setExcelAlert] = useState(false);
	const [protocolAlert, setProtocolAlert] = useState(false);

	const [currentPage, setCurrentPage] = useState(1);
	const [itemsPerPage, setItemsPerPage] = useState([]);

	const [initialDate, setInitialDate] = useState('');
	const [finalDate, setFinalDate] = useState('');

	const [currentUser, setCurrentUser] = useState({
		unit: '',
		status: '',
		card: 'NOTIFICADO',
	});
	const [icons, setIcons] = useState({
		0: {
			icon: Relogio,
			status: 'notificados',
			descrição: 'Aguardando Classificação',
			noPrazo: '33',
			atrasados: '25',
		},
		1: {
			icon: Lupa,
			status: 'classificados',
			descrição: 'Em Investigação',
			noPrazo: '20',
			atrasados: '25',
		},
		2: {
			icon: Check,
			status: 'investigados',
			descrição: 'Avaliação Final',
			concluidos: '12',
			pendentes: '7',
		},
	});
	const [filter, setFilter] = useState('');
	const [isOpen, setIsOpen] = useState(false);
	const [showAlert, setShowAlert] = useState(true);
	const [selectedUnit, setSelectedUnit] = useState('');

	const handleDates = (event) => {
		setExcelAlert(false);
		const { value, id } = event.target;
		if (id === 'initialDate') {
			setInitialDate(value);
		} else {
			setFinalDate(value);
		}
	};

	const handleClick = async (data) => {
		const token = JSON.parse(Cookies.get('user')).token;
		let filter;
		if (allNotes.length > 0) {
			filter = allNotes.filter(
				(note) =>
					note?.unidade_nome === currentUser.unit &&
					note?.status === currentUser.card
			);
		}
		const marcos = await requestAllInvestigations(token);
		let investigações = marcos?.filter(
			(marco) => marco.unidade_nome === currentUser.unit
		);

		const paulo = await requestAllInvestigations(token, 'REINVESTIGACAO');
		const rein = paulo?.filter(
			(note) => note.unidade_nome === currentUser.unit
		);

		switch (data) {
			case 'notificados':
				setListLoading(true);
				setNotes(
					allNotes?.filter(
						(note) =>
							note.unidade_nome === currentUser.unit &&
							note.status === 'NOTIFICADO'
					)
				);
				setItemsPerPage(
					allNotes?.filter(
						(note) =>
							note.unidade_nome === currentUser.unit &&
							note.status === 'NOTIFICADO'
					).length > 10
						? allNotes
								?.filter(
									(note) =>
										note.unidade_nome ===
											currentUser.unit &&
										note.status === 'NOTIFICADO'
								)
								.slice(0, 10)
						: allNotes?.filter(
								(note) =>
									note.unidade_nome === currentUser.unit &&
									note.status === 'NOTIFICADO'
						  )
				);
				setCurrentUser({ ...currentUser, card: 'NOTIFICADO' });
				setCurrentFilter([]);
				setTimeout(() => {
					setListLoading(false);
				}, 1000);

				break;

			case 'classificados':
				setListLoading(true);

				setNotes([...investigações, ...rein]);
				setItemsPerPage(
					[...investigações, ...rein].length > 10
						? [...investigações, ...rein].slice(0, 10)
						: [...investigações, ...rein]
				);
				setCurrentUser({ ...currentUser, card: 'CLASSIFICADO' });
				setCurrentFilter([]);
				setTimeout(() => {
					setListLoading(false);
				}, 1000);

				break;
			case 'investigados':
				setListLoading(true);
				setNotes(
					allNotes?.filter(
						(note) =>
							(note.unidade_nome === currentUser.unit &&
								note.status === 'INVESTIGADO') ||
							(note.unidade_nome === currentUser.unit &&
								note.status === 'CONCLUIDO')
					)
				);
				setItemsPerPage(
					allNotes?.filter(
						(note) =>
							(note.unidade_nome === currentUser.unit &&
								note.status === 'INVESTIGADO') ||
							(note.unidade_nome === currentUser.unit &&
								note.status === 'CONCLUIDO')
					) > 10
						? allNotes
								?.filter(
									(note) =>
										(note.unidade_nome ===
											currentUser.unit &&
											note.status === 'INVESTIGADO') ||
										(note.unidade_nome ===
											currentUser.unit &&
											note.status === 'CONCLUIDO')
								)
								.slice(0, 10)
						: allNotes?.filter(
								(note) =>
									(note.unidade_nome === currentUser.unit &&
										note.status === 'INVESTIGADO') ||
									(note.unidade_nome === currentUser.unit &&
										note.status === 'CONCLUIDO')
						  )
				);
				setCurrentUser({ ...currentUser, card: 'INVESTIGADO' });
				setCurrentFilter([]);
				setTimeout(() => {
					setListLoading(false);
				}, 1000);
				break;
			default:
				console.log('Valor não corresponde a nenhum caso');
		}
	};

	const handleFilters = async (event) => {
		const { value, id, checked } = event.target;
		const hoje = Date.now();

		const token = JSON.parse(Cookies.get('user')).token;
		const userName = JSON.parse(Cookies.get('user')).userName;

		if (checked === true) {
			setFilters((prev) => [...prev, id]);

			let newNotes = notes;

			if ([...filters, id].includes('minhas-investigacoes')) {
				let result = await requestNotesByInv(token, userName);
				if (!result.detail) {
					newNotes = result;
					let toma = result?.filter(
						(note) =>
							note.status !== 'CONCLUIDO' &&
							note.status !== 'NOTIFICADO' &&
							note.unidade_id ===
								JSON.parse(Cookies.get('user')).id
					);
					newNotes = toma;
				} else {
					newNotes = [];
				}
			}

			if ([...filters, id].includes('atrasados')) {
				if (currentUser.card === 'CLASSIFICADO') {
					if (newNotes[0]?.prazo_investigacao) {
						const result = newNotes.filter(
							(item) => item.protocolo_info.atraso === true
						);
						newNotes = result;
					} else {
						const result = newNotes.filter(
							(item) =>
								new Date(item?.prazo_investigacao).getTime() <=
								Date.now()
						);

						newNotes = result;
					}
				} else {
					newNotes = [];
				}
			}

			if (
				[...filters, id].includes('pendentes') &&
				currentUser.card === 'INVESTIGADO'
			) {
				let result = newNotes.filter(
					(item) =>
						item.status === 'INVESTIGADO' ||
						item.status === 'REINVESTIGACAO'
				);
				newNotes = result;
			}

			if (newNotes.length > 0) {
				setCurrentFilter(newNotes);
				setItemsPerPage(
					newNotes.length > 10 ? newNotes.slice(0, 10) : newNotes
				);
			} else {
				setCurrentFilter('Nenhuma notificação encontrada');
			}
		} else {
			setFilters((prev) => prev.filter((item) => item !== id));
			let newNotes = notes;
			if (
				filters
					.filter((item) => item !== id)
					.includes('minhas-investigacoes')
			) {
				let result = await requestNotesByInv(token, userName);

				if (!result.detail) {
					newNotes = result;
					let toma = result?.filter(
						(note) =>
							note.status !== 'CONCLUIDO' &&
							note.status !== 'NOTIFICADO' &&
							note.unidade_id ===
								JSON.parse(Cookies.get('user')).id
					);
					newNotes = toma;
				} else {
					newNotes = [];
				}
			}

			if (
				[filters.filter((item) => item !== id), id].includes(
					'atrasados'
				)
			) {
				if (currentUser.card === 'CLASSIFICADO') {
					const result = newNotes.filter((item) => {
						const dataNotificacao = new Date(
							item?.notificacao?.data_notificacao
						);
						const hoje = new Date();
						const diffEmMs = hoje - dataNotificacao;
						const diffEmDias = diffEmMs / (1000 * 60 * 60 * 24);

						return diffEmDias < 10 || diffEmDias >= 10;
					});
					newNotes = result;
				} else {
					const result = newNotes.filter((item) => {
						const dataNotificacao = new Date(item.data_notificacao);
						const hoje = new Date();
						const diffEmMs = hoje - dataNotificacao;
						const diffEmDias = diffEmMs / (1000 * 60 * 60 * 24);

						return diffEmDias < 10 || diffEmDias >= 10;
					});
					newNotes = result;
				}
			}

			if (
				filters.filter((item) => item !== id).includes('pendentes') &&
				currentUser.card === 'INVESTIGADO'
			) {
				let result = newNotes.filter(
					(item) =>
						item.status === 'INVESTIGADO' ||
						item.status === 'REINVESTIGACAO'
				);
				newNotes = result;
			}

			if (newNotes.length > 0) {
				setCurrentFilter(newNotes);

				setItemsPerPage(
					newNotes.length > 10 ? newNotes.slice(0, 10) : newNotes
				);
			} else {
				setCurrentFilter('Nenhuma notificação encontrada');
			}
		}
	};

	const conteudo = 'Pendente';

	const meses = [
		'janeiro',
		'fevereiro',
		'março',
		'abril',
		'maio',
		'junho',
		'julho',
		'agosto',
		'setembro',
		'outubro',
		'novembro',
		'dezembro',
	];

	const handlePaginate = (event) => {
		const { id } = event.target;
		let totalItems;

		currentFilter.length > 0 &&
		currentFilter !== 'Nenhuma notificação encontrada'
			? (totalItems = currentFilter)
			: (totalItems = notes);

		const pageSize = 10;
		const totalParts = Math.ceil(totalItems.length / pageSize);

		const parts = [];
		for (let i = 0; i < totalParts; i++) {
			parts.push(totalItems.slice(i * pageSize, (i + 1) * pageSize));
		}

		const pageIndex = parseInt(id, 10) - 1;
		const result = parts[pageIndex] || [];

		setItemsPerPage(result);
		setCurrentPage(parseInt(id, 10));
	};

	const handleInvNotesFilter = async () => {
		setInvFilter(true);
		const token = JSON.parse(Cookies.get('user')).token;
		const userName = JSON.parse(Cookies.get('user')).userName;
		let result = await requestNotesByInv(token, userName);

		if (!result.detail) {
			let toma = result?.filter(
				(note) =>
					note.status !== 'CONCLUIDO' && note.status !== 'NOTIFICADO'
			);

			setCurrentFilter(toma);
		} else {
			setCurrentFilter([]);
		}
	};

	const handleAvalNotesFilter = async (param) => {
		let aux = notes;

		if (param === 'CONCLUIDO') {
			aux = notes.filter((item) => {
				return item.status === 'CONCLUIDO';
			});
			aux.length > 0
				? setCurrentFilter(aux)
				: setCurrentFilter('Nenhuma notificação encontrada');
		} else {
			aux = notes.filter((item) => {
				return item.status === 'INVESTIGADO';
			});
			aux.length > 0
				? setCurrentFilter(aux)
				: setCurrentFilter('Nenhuma notificação encontrada');
		}
	};

	const handleExcelExport = async () => {
		if (
			(new Date(finalDate) - new Date(initialDate)) / 86400000 >= 62 ||
			(new Date(finalDate) - new Date(initialDate)) / 86400000 <= -62 ||
			new Date(finalDate) < new Date(initialDate)
		) {
			setExcelAlert(true);
		} else {
			const user = JSON.parse(Cookies.get('user'));
			const user_token = user.token;
			const unit_token = user.id;

			let currentToken = '';

			if (unit_token !== undefined) {
				currentToken = unit_token
					.replace(/-/g, '')
					.split('')
					.reverse()
					.join('');
			} else {
				if (excelToken.includes('-')) {
					currentToken = excelToken
						.replace(/-/g, '')
						.split('')
						.reverse()
						.join('');
				} else {
					currentToken = excelToken;
				}
			}
			const response = await requestExcelExport(
				user_token,
				currentToken,
				initialDate,
				finalDate
			);

			if (!response.error) {
				const blob = response.blob;
				const url = window.URL.createObjectURL(blob);
				const a = document.createElement('a');
				a.href = url;

				// Define um nome de arquivo padrão — pode ajustar conforme necessário.
				a.download = `consolidado-notificações-${currentUser?.unit}.xlsx`;
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);

				// Libera memória.
				window.URL.revokeObjectURL(url);
			} else {
				console.error(response.error);
				// Aqui pode exibir um toast ou alerta.
			}
		}
	};

	const handleSearchProtocol = (protocolo) => {
		/* 	console.log(protocolo);
		console.log(notes);
		console.log(itemsPerPage);
		console.log(currentFilter); */
		setListLoading(true);
		let result = notes.filter((note) => note.protocolo === protocolo);
		if (result.length === 0 && protocolo.length === 0) {
			setItemsPerPage(
				notes.length > 0
					? notes.slice(0, 10)
					: currentFilter.slice(0, 10)
			);
			setListLoading(false);
		} else {
			setTimeout(() => {
				setCurrentFilter(result);
				setItemsPerPage(
					(result.length === 0 ? [] : result).slice(0, 10)
				);
				setListLoading(false);
			}, 1000);
		}
	};

	const ListUnits = async () => {
		const result = await requestNewUnits();
		if (!result.error) {
			setListUnits(result);
		}
	};

	const toggleAccordion = async () => {
		setIsOpen(!isOpen);
	};

	const filteChange = (e) => {
		setFilter(e.target.id);

		let result = notes.sort((a, b) =>
			a[e.target.id] > b[e.target.id] ? 1 : -1
		);

		if (filter === e.target.id) {
			result = notes.sort((a, b) =>
				a[e.target.id] < b[e.target.id] ? 1 : -1
			);

			setCurrentFilter(result);
		} else {
			setCurrentFilter(result);
		}
	};

	const findValueFromDisplay = (displayValue) => {
		let word = displayValue?.trim();
		const result = Json.find((item) => item.value === word);
		return result ? result.display : '';
	};

	const goToClassification = (caso, card, note) => {
		const user = JSON.parse(Cookies.get('user')).unidade;
		if (
			caso === 'CLASSIFICADO' &&
			card === 'CLASSIFICADO' &&
			user === 'subhue' &&
			JSON.parse(Cookies.get('user')).cargo !== 'desenvolvedor'
		) {
			setPropNotes(note);
			setPropCard({ caso: 'NOTIFICADO', card: 'CLASSIFICADO' });
			setLoading(true);
			setDuality(!duality);
			setTimeout(() => {
				setLoading(false);
			}, 2000);
		} else {
			if (caso === card) {
				setPropNotes(note);
				setPropCard({ caso, card });
				setLoading(true);
				setDuality(!duality);
				setTimeout(() => {
					setLoading(false);
				}, 2000);
			}
			if (caso !== card) {
				setPropNotes(note);
				setPropCard({ caso, card });
				setLoading(true);
				setDuality(!duality);
				setTimeout(() => {
					setLoading(false);
				}, 2000);
			}
		}
	};

	const handleRequest = async (developerUnit, token) => {
		let userCookie = JSON.parse(Cookies.get('user'));
		const result = await requestListNotes(
			userCookie.token,
			token?.replace(/-/g, '').split('').reverse().join('')
		);
		let unit = userCookie.unidade;

		if (
			JSON.parse(Cookies.get('user')).cargo === 'desenvolvedor' ||
			JSON.parse(Cookies.get('user')).unidade === 'subhue'
		) {
			unit = developerUnit;
		}

		const marcos = await requestAllInvestigations(userCookie.token);

		const paulo = await requestAllInvestigations(
			userCookie.token,
			'REINVESTIGACAO'
		);
		const rein = paulo?.filter((note) => note.unidade_nome === unit);

		let investigações = marcos?.filter(
			(marco) => marco.unidade_id === token
		);
		/* 	console.log(investigações.filter((i))); */
		if (token === undefined && userCookie.id) {
			investigações = marcos?.filter(
				(marco) => marco.unidade_id === userCookie.id
			);
		}
		function agruparNotificacoesPorStatus(notificacoes) {
			// Verificar se 'notificacoes' é um array
			if (!Array.isArray(notificacoes)) {
				console.error('notificacoes não é um array:', notificacoes);
				return {
					notificados: [],
					classificados: [],
					investigados: [],
					concluidos: [],
				};
			}

			const notificacoesFiltradas = notificacoes.filter(
				(n) => n?.unidade_nome === unit
			);
			return {
				notificados: notificacoesFiltradas.filter(
					(n) => n.status === 'NOTIFICADO'
				),
				classificados: [
					...investigações.filter((n) => n.status === 'CLASSIFICADO'),
					...rein,
				],

				investigados: notificacoesFiltradas.filter(
					(n) => n.status === 'INVESTIGADO'
				),
				concluidos: notificacoesFiltradas.filter(
					(n) => n.status === 'CONCLUIDO'
				),
			};
		}

		setNotifyNumbers(agruparNotificacoesPorStatus(result));
		if (!result.error) {
			let filter = result.filter(
				(note) =>
					note?.unidade_nome === unit &&
					note?.status === currentUser.card
			);
			setAllNotes(result);
			setNotes(filter);
			setItemsPerPage(filter.length > 10 ? filter.slice(0, 10) : filter);
		} else {
			console.log(result.error);
		}
	};

	/* 	teste */

	useEffect(() => {
		let userCookie = JSON.parse(Cookies.get('user'));
		if (Cookies.get('cache')) {
			setExcelToken(
				JSON.parse(Cookies.get('cache'))
					?.unit_id?.replace(/-/g, '')
					.split('')
					.reverse()
					.join('')
			);
		} else {
			setExcelToken(
				userCookie?.id?.replace(/-/g, '').split('').reverse().join('')
			);
		}
		if (userCookie.unidade === 'subhue') {
			setUnitList(true);
		}
		ListUnits();

		if (userCookie?.permissao.length > 1) {
			setUserPermissions(userCookie.permissao);
			setChoseStatus(true);
			setCurrentUser({ ...currentUser, unit: userCookie.unidade });

			if (Cookies.get('cache')) {
				let cache = JSON.parse(Cookies.get('cache'));
				if (cache) {
					let { unit_id, unit_name, status, card } = cache;
					setCurrentUser({ status, card, unit: unit_name });
					setSelectedUnit(unit_name);

					handleRequest(unit_name, unit_id);
				}
			} else {
				handleRequest();
			}
		} else {
			setUserPermissions(userCookie.permissao);
			setCurrentUser({
				...currentUser,
				unit: userCookie.unidade,
				status:
					userCookie.permissao[0] === 'Investigadores'
						? 'CLASSIFICADO'
						: userCookie.permissao[0] === 'Classificadores'
						? 'NOTIFICADO'
						: 'NOTIFICADO',
			});

			handleRequest();
		}
		const localData = Cookies.get('user');
		if (localData) {
			let user = JSON.parse(Cookies.get('user'));
			if (
				user.cargo === 'desenvolvedor' ||
				user.unidade === 'subhue' ||
				user.cargo === 'gestor'
			) {
				if (
					user.cargo === 'desenvolvedor' ||
					user.unidade === 'subhue'
				) {
					setCurrentUser({
						...currentUser,
						unit: '',
					});
				}
				setShowAlert(false);
			}
			if (
				user.permissao.includes('Classificadores') ||
				user.permissao.includes('Investigadores')
			) {
				setShowAlert(false);
			}
		}
		if (Cookies.get('cache')) {
			let cache = JSON.parse(Cookies.get('cache'));
			if (cache) {
				let { unit_id, unit_name, status, card } = cache;
				setCurrentUser({ status, card, unit: unit_name });
				setSelectedUnit(unit_name);

				handleRequest(unit_name, unit_id);
			}
		}
	}, []);

	const handleSelection = async (value, id) => {
		let storageData = {
			unit_id: id,
			unit_name: value,
			status: currentUser.status,
			card: currentUser.card,
		};

		Cookies.set('cache', JSON.stringify(storageData), {
			expires: 1,
		});
		setCurrentUser({ ...currentUser, unit: value });

		setExcelToken(id === 'vazio' ? '' : id);

		setSelectedUnit(value);
		/* console.log('unidade selecionada', value);
		console.log('id selecionada', id); */

		handleRequest(value, id);
	};

	const selectRef = useRef(null);

	return (
		<div className='flex flex-col mx-auto min-h-screen'>
			<NavBar />
			{!duality && (
				<div className='sm:top-[80px] mt-[80px] bg-[#F0F4F8] w-full'>
					<div className='w-[90%] sm:w-[95%] mx-auto items-center max-w-[1136px]'>
						<div className='px-[32px] py-[36px]'>
							<p className='text-[20px] md:text-[32px] font-semibold w-full text-center text-[#004A80]'>
								Avaliação das notificações de incidentes
							</p>
						</div>
						<div className='w-[90%] sm:w-[100%] mx-auto items-center max-w-[1136px] flex '>
							<div className='flex flex-col '></div>

							{JSON.parse(Cookies.get('user')).unidade ===
								'subhue' ||
							JSON.parse(Cookies.get('user')).cargo ===
								'gestor' ||
							JSON.parse(Cookies.get('user')).permissao.includes(
								'Gestores'
							) ||
							JSON.parse(Cookies.get('user')).permissao.length >
								1 ? (
								<div className=' w-[100%] flex flex-col sm:gap-3   md:justify-center gap-4 mt-10  rounded-lg p-4 '>
									{/* Escolha o serviço */}
									<p className='text-[#004A80] font-semibold  text-2xl'>
										{' '}
										Filtros
									</p>
									<div className='flex sm:flex-row  flex-col gap-10'>
										{JSON.parse(Cookies.get('user'))
											.permissao.length > 1 && (
											<div className='w-full flex flex-col justify-start  max-w-[400px] items-start  '>
												<p className='text-[14px] md:text-[17px] items-start font-semibold text-[#004A80] mb-2 '>
													Categoria
												</p>
												<div className='grid gap-[10px] mt-1 w-full'>
													{userPermissions
														.filter(
															(permission) =>
																permission !==
																'Gestores'
														) // Filtra a lista antes do map
														.map(
															(
																permission,
																index
															) => (
																<div
																	key={
																		index +
																		'permix'
																	}
																	className='flex items-center gap-2'>
																	<input
																		type='radio'
																		name='profissional'
																		defaultChecked={
																			Cookies.get(
																				'cache'
																			)
																				? (JSON.parse(
																						Cookies.get(
																							'cache'
																						)
																				  )
																						.status ===
																						'CLASSIFICADO' &&
																						permission ===
																							'Investigadores') ||
																				  (JSON.parse(
																						Cookies.get(
																							'cache'
																						)
																				  )
																						.status ===
																						'NOTIFICADO' &&
																						permission ===
																							'Classificadores')
																					? true
																					: undefined
																				: undefined
																		}
																		className='w-4 h-4'
																		onClick={() => {
																			setCurrentUser(
																				{
																					...currentUser,
																					status:
																						permission ===
																						'Investigadores'
																							? 'CLASSIFICADO'
																							: 'NOTIFICADO',
																				}
																			);
																		}}
																		id={
																			permission
																		}
																	/>
																	<label
																		htmlFor={
																			permission
																		}
																		className='text-[#4e4e4e] text-[14px] font-medium'>
																		{
																			permission
																		}
																	</label>
																</div>
															)
														)}
												</div>
											</div>
										)}
										{/* Escolha a unidade */}
										<div className='w-full max-w-[400px] flex flex-col justify-start'>
											{JSON.parse(Cookies.get('user'))
												.unidade === 'subhue' ||
											JSON.parse(Cookies.get('user'))
												.cargo === 'desenvolvedor' ? (
												<>
													<p className='text-[14px] md:text-[17px] items-start font-semibold text-[#004A80] mb-2'>
														Unidade
													</p>
													{/* {Cookies.get('cache')
														? console.log(
																JSON.stringify({
																	id: JSON.parse(
																		Cookies.get(
																			'cache'
																		)
																	).unit_id,
																	nome: JSON.parse(
																		Cookies.get(
																			'cache'
																		)
																	).unit_name,
																})
														  )
														: ''} */}
													<select
														ref={selectRef}
														onChange={(event) => {
															try {
																const value =
																	event
																		?.target
																		?.value;
																if (!value)
																	return;

																const {
																	id,
																	nome,
																} =
																	JSON.parse(
																		value
																	);
																if (
																	id &&
																	nome
																) {
																	handleSelection(
																		nome,
																		id
																	);
																}
															} catch (error) {
																console.warn(
																	'Erro ao fazer parse do valor:',
																	error
																);
															}
														}}
														className='p-2 border-[1px] border-[#d3d3d3] w-[100%] rounded-lg text-sm md:text-base h-[40px]'>
														<option
															value={
																Cookies.get(
																	'cache'
																)
																	? JSON.stringify(
																			{
																				id: JSON.parse(
																					Cookies.get(
																						'cache'
																					)
																				)
																					.unit_id,
																				nome: JSON.parse(
																					Cookies.get(
																						'cache'
																					)
																				)
																					.unit_name,
																			}
																	  )
																	: JSON.stringify(
																			{
																				id: 'vazio',
																				nome: 'vazio',
																			}
																	  )
															}>
															{Cookies.get(
																'cache'
															)
																? JSON.parse(
																		Cookies.get(
																			'cache'
																		)
																  )?.unit_name +
																  ' - Unidade selecionada'
																: 'Seleciona a unidade'}
														</option>
														{listUnits.map(
															(unit, index) => (
																<option
																	value={JSON.stringify(
																		{
																			id: unit.id,
																			nome: unit.nome,
																		}
																	)}
																	key={
																		index +
																		'pork'
																	}>
																	{unit?.nome}
																</option>
															)
														)}
													</select>
													{selectedUnit && (
														<p className='mt-2 text-green-600'>
															Informações
															Atualizadas✅
														</p>
													)}
												</>
											) : null}
										</div>

										{/* Baixar excel */}
										{(JSON.parse(Cookies.get('user'))
											.cargo === 'desenvolvedor' ||
											JSON.parse(Cookies.get('user'))
												.unidade === 'subhue' ||
											JSON.parse(Cookies.get('user'))
												.cargo === 'gestor') && (
											<div className='w-full max-w-[350px] items-start border-[2px] border-[#d8d8d8] rounded-lg bg-[#fdfdfd] p-4 shadow-md'>
												<div className='my-auto flex flex-col justify-center  gap-2'>
													<p className='text-[14px] md:text-[16px] items-start font-medium text-[#004A80] '>
														Exportar documento
													</p>{' '}
													<div className='flex flex-col rounded-lg w-full'>
														<div className='flex flex-row gap-3 w-full'>
															<div className='flex flex-col flex-1 w-full'>
																<p className='text-[10px] text-gray-400 font-medium'>
																	Data inicial
																</p>
																<input
																	type='date'
																	id='initialDate'
																	value={
																		initialDate
																	}
																	onChange={
																		handleDates
																	}
																	className='border transition-all duration-300 text-[#a0a0a0] border-gray-300 rounded-lg p-2 text-sm w-[110px] sm:w-[80px] lg:w-[120px] xl:w-full focus:outline-none focus:border-blue-400 focus:ring-1 '
																/>
															</div>
															<div className='hidden sm:flex items-center justify-center'>
																<div className='bg-[#c5c5c5] w-2 h-[2px] mt-4'></div>
															</div>

															<div className='flex flex-col flex-1 w-full'>
																<p className='text-[10px] text-gray-400 font-medium'>
																	Data final
																</p>
																<input
																	type='date'
																	value={
																		finalDate
																	}
																	id='finalDate'
																	onChange={
																		handleDates
																	}
																	className='border transition-all duration-300 text-[#a0a0a0] border-gray-300 rounded-lg p-2 text-sm w-[110px] sm:w-[80px] lg:w-[120px] xl:w-full focus:outline-none focus:border-blue-400 focus:ring-1 '
																/>
															</div>
														</div>
													</div>
													<div className='w-full flex justify-end'>
														<button
															onClick={() =>
																handleExcelExport()
															}
															disabled={
																excelToken ===
																	'' ||
																excelToken ===
																	undefined ||
																initialDate.length ===
																	0 ||
																finalDate.length ===
																	0
															}
															className='px-2 py-1 rounded-[5px] enabled:shadow-md border-2  border-gray-200  flex justify-center enabled:text-white font-medium enabled:bg-[#1E6D41] text-shadow-md enabled:hover:bg-[#195a36] transition-all duration-200  gap-2 items-center w-full enabled:border-[#1E6D41] enabled:hover:border-[#195a36] text-gray-200 '>
															<RiFileExcel2Line className='scale-[110%]' />
															Exportar em Excel
														</button>

														{excelAlert === true ? (
															<div className='fixed inset-0 flex items-center justify-center bg-black/50 z-50'>
																<div className='shadow-lg flex flex-col  text-center bg-[#e7e7e7] text-[#a3a3a3] gap-8 font-semibold font-inter w-[350px] h-[180px] px-4  rounded-xl'>
																	<div className=''></div>

																	<>
																		<p className='text-[#a3a3a3] text-lg'>
																			{new Date(
																				finalDate
																			) <
																			new Date(
																				initialDate
																			)
																				? 'A data final não pode ser menor que a data inicial'
																				: 'O período para exportação não pode ultrapassar 62 dias.'}
																		</p>
																		<div className='flex justify-center gap-4'>
																			<button
																				onClick={() => {
																					setExcelAlert(
																						false
																					);
																					setFinalDate(
																						''
																					);
																				}}
																				className='bg-[#004A80] rounded-md p-1 px-5 text-white hover:border-[#1b425e] border-[#004A80] border-[1px] hover:bg-[#1b425e]'>
																				Continuar
																			</button>{' '}
																		</div>
																	</>
																</div>
															</div>
														) : null}
													</div>
												</div>
											</div>
										)}
									</div>
								</div>
							) : null}
						</div>
					</div>
				</div>
			)}
			{/* 	{console.log(
				'notificações no display:',
				notes,
				'notificações filtradas:',
				currentFilter
			)}
 */}
			{duality ? (
				<div>
					{loading ? (
						<div className='mt-[500px] flex-grow h-screen'>
							<Loading />
						</div>
					) : (
						<div className='grid my-[100px] sm:w-full'>
							<div className='mx-auto w-full px-10 sm:w-[90%] max-w-[1136px]'>
								<button
									className='bg-[#E3E3E3] p-1 text-[#757575] font-semibold mx-auto w-[100px] rounded-md hover:bg-[#757575] transition-all duration-200 hover:text-[#f0f0f0]'
									onClick={() => {
										window.location.reload();
									}}>
									{' '}
									Voltar
								</button>
							</div>
							<ClassInvForm
								notificacao={{
									...(propNotes?.notificacao
										? propNotes.notificacao
										: propNotes),
									unidade_nome: propNotes?.unidade_nome,
									protocolo: propNotes?.protocolo,
									status:
										propNotes.status === 'REINVESTIGACAO'
											? 'CLASSIFICADO'
											: propNotes.status,
								}}
								cards={propCard}
							/>
						</div>
					)}
				</div>
			) : (
				<div className='font-inter flex flex-col flex-grow '>
					{showAlert ? (
						<section className='bg-[#004A80] mt-[150px] rounded-md w-[90%] sm:w-[70%] md:w-[60%] lg:w-[50%]  mx-auto my-auto'>
							<div className='py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6'>
								<div className='mx-auto max-w-screen-sm text-center'>
									<h1 className='mb-4 text-white text-5xl sm:text-6xl lg:text-7xl tracking-tight font-extrabold text-primary-600'>
										401
									</h1>
									<p className='mb-10 text-2xl sm:text-3xl md:text-4xl tracking-tight font-bold text-slate-100'>
										Acesso Negado
									</p>
									<p className='mb-7 text-sm sm:text-base md:text-lg font-light text-gray-300'>
										Você não possui permissão para acessar
										este campo. Entre em contato com o
										administrador(a) da sua unidade para
										solicitação de acesso.
									</p>
									<a
										href='/login'
										className='inline-flex hover:scale-105 transition-transform text-gray-300 bg-primary-600 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center my-4'>
										Volte para a Tela de Login
									</a>
								</div>
							</div>
						</section>
					) : (
						<div>
							<div className='w-[90%] sm:w-[95%] mt-[24px] mx-auto items-center max-w-[1136px] mb-10 flex-grow'>
								{/* CARDS */}
								<div className='flex flex-wrap gap-y-8 gap-[70px] justify-center min-h-[440px]'>
									{/* CARDS 1 */}
									{Object.keys(icons).map((icon, index) => (
										<div
											key={index}
											className='flex flex-col justify-between items-center bg-[#F5F5F5] shadow-md w-[330px] p-[18px] rounded-lg gap-y-[18px] min-h-[440px] border-[2px]'>
											<div className='w-full justify-center grid gap-[20px]'>
												<div className='grid justify-center'>
													<img
														alt='icone do status'
														src={
															icons[`${index}`]
																.icon
														}></img>
												</div>
												<div className='grid text-center leading-none text-[#004A80] text-[18px] md:text-[28px] font-bold'>
													{
														icons[`${index}`]
															.descrição
													}
												</div>
											</div>
											<div className='  w-full text-center grid gap-[18px] '>
												<div className='grid justify-center text-[#004A80] text-[36px] font-bold'>
													{icons[`${index}`]
														.concluidos &&
													notifyNumbers
														? notifyNumbers
																.concluidos
																.length +
														  notifyNumbers
																.investigados
																.length
														: notifyNumbers
														? notifyNumbers[
																icons[
																	`${index}`
																].status
														  ].length
														: ''}
												</div>
												<div className=' w-full grid gap-[10px]'>
													<div className='bg-[#E3E3E3] h-[2px] w-full'></div>
													<div className='grid justify-center w-full text-[14px] text-[#757575]'>
														Notificações{' '}
														{icons[`${index}`]
															.descrição ===
														'Avaliação Final'
															? 'Concluídas'
															: icons[`${index}`]
																	.descrição}
													</div>
												</div>
												<div className=' flex gap-[32px] justify-center my-[10px]'>
													<div
														className={`grid ${
															icons[`${index}`]
																.concluidos
																? 'text-[#32993E]'
																: 'text-[#00C0F3]'
														} `}>
														<div className='grid font-semibold text-[20px]'>
															{notifyNumbers
																? icons[
																		`${index}`
																  ].concluidos
																	? notifyNumbers
																			.concluidos
																			.length
																	: notifyNumbers[
																			icons[
																				`${index}`
																			]
																				.status
																	  ].length -
																	  notifyNumbers[
																			icons[
																				index
																			]
																				.status
																	  ].filter(
																			(
																				notify
																			) =>
																				notify
																					?.protocolo_info
																					?.atraso
																	  ).length
																: ''}
														</div>
														<div className='grid  font-normal text-[16px]'>
															{icons[`${index}`]
																.noPrazo
																? 'No Prazo'
																: 'Concluídos'}
														</div>
													</div>
													<div className=' w-[2px] h-[100%] content-center my-auto bg-[#004A80] rounded-lg'></div>
													<div className='grid text-[#B74644]'>
														<div className='grid  font-semibold text-[20px]'>
															{notifyNumbers &&
																(() => {
																	const status =
																		icons[
																			index
																		]
																			.status;
																	const data =
																		notifyNumbers[
																			status
																		] || [];

																	return status ===
																		'investigados'
																		? data.length
																		: data.filter(
																				(
																					notify
																				) =>
																					notify
																						?.protocolo_info
																						?.atraso
																		  )
																				.length;
																})()}
														</div>
														<div className='grid font-normal text-[16px]'>
															{icons[`${index}`]
																.atrasados
																? 'Em Atraso'
																: 'Pendentes'}
														</div>
													</div>
												</div>
												<button
													onClick={() => {
														handleClick(
															icons[`${index}`]
																.status
														);
														setInvFilter(false);
													}}
													className={`w-full py-[8px] hover:border-transparent border-[2px] transition-all duration-200  text-[#757575] hover:bg-[#004A80] rounded-lg hover:text-[#F5F5F5] ${
														icons[`${index}`].status
															.slice(
																0,
																icons[
																	`${index}`
																].status
																	.length - 1
															)
															.toUpperCase() ===
														currentUser.card
															? 'bg-[#004A80] text-[#F5F5F5] border-transparent'
															: ' border-[#757575]'
													}  `}>
													<div className='flex justify-center gap-[12px]'>
														<IoMdEye className='scale-[120%]' />
														<p className='text-[12px] font-normal'>
															Visualizar
														</p>
													</div>
												</button>
											</div>
										</div>
									))}
								</div>
								<div className='w-full h-[1px] bg-[#E3E3E3] my-[28px] '></div>
								{/* LISTA */}
								<div className='border-[2px] border-[#E3E3E3]  py-[32px] flex flex-col  rounded-lg gap-[22px]'>
									<div className='flex justify-between pr-[22px]'>
										<div className='flex gap-[18px]'>
											<div className='w-[8px] h-[25px] bg-[#00C0F3]'></div>
											<p className='text-[#757575] text-[12px] sm:text-[16px]'>
												Notificações aguardando{' '}
												{currentUser.card ===
												'NOTIFICADO'
													? 'classificação'
													: currentUser.card ===
													  'CLASSIFICADO'
													? 'investigação'
													: 'avaliação final'}
											</p>
										</div>

										<div className='flex flex-col sm:flex-row gap-[22px] relative '>
											<div className=' max-h-[40px] flex justify-end'>
												{' '}
												<input
													type='text'
													placeholder='Pesquisar protocolo'
													onChange={(event) =>
														setProtocolFilter(
															event.target.value
														)
													}
													className='sm:w-[280px] text-[#a7a7a7] font-normal text-[16px]  w-[80%] border-[#E3E3E3]  border-[1px] rounded-md px-2 py-1 rounded-r-none placeholder:text-[#E3E3E3]'></input>
												<button
													onClick={() =>
														handleSearchProtocol(
															protocolFilter
														)
													}
													className='hover:text-[#f3f3f3] transition-all duration-200 hover:bg-[#004A80] text-[#004A80]  sm:w-[40px] h-[40px] border-[#E3E3E3] border-[1px] rounded-md px-2 py-1 rounded-l-none border-l-0 placeholder:text-[#E3E3E3]'>
													<div className='flex justify-center   items-center h-full w-full '>
														<FaSearch className='w-[20px] h-[20px]' />
													</div>
												</button>
											</div>

											<div className='w-full sm:w-auto flex justify-end'>
												<button
													onClick={() =>
														toggleAccordion()
													}
													className={`border-[2px] transition-all duration-700 border-[#757575] justify-between rounded-[10px] text-[#757575] px-[8px]  flex gap-x-[8px]   hover:bg-[#757575] h-full hover:text-[white] ${
														isOpen
															? 'bg-[#757575] text-[white] w-auto'
															: 'w-auto bg-[#eeeeee]'
													}`}>
													<div className='h-full content-center  hover:'>
														<FaFilter />
													</div>
													<div className='flex landing-none justify-start items-center h-full w-full '>
														Filtrar
													</div>
												</button>
											</div>
											<div
												className={`absolute ${
													isOpen
														? 'max-h-[1000px] w-[220px] px-3 py-3.5 border-[1px] border-[#e7e7e7]'
														: 'max-h-0 py-0 w-[220px]  px-3 border-[0px] '
												} overflow-hidden transition-all duration-700 ease-in-out right-0 grid gap-2 rounded-md shadow-md bg-[#ffffff]  text-[#6e6e6e] sm:mt-[50px] mt-[100px] `}>
												{/* <button
													id='status'
													className='flex items-center text-[14px] font-medium gap-[8px] justify-between hover:text-[#4aa7dd]   text-[#347bbd]'
													onClick={(e) =>
														filteChange(e)
													}>
													Status
													<FaSortAlphaDown
														id='status'
														onClick={(e) => {
															filteChange(e);
															setInvFilter(false);
														}}
													/>
												</button> */}
												<label
													htmlFor='atrasados'
													className='flex items-center text-[14px] font-normal  gap-2  cursor-pointer '>
													<input
														type='checkbox'
														id='atrasados'
														className='accent-[#757575] text-[#1e2e58] border-[1px]  rounded-full h-4 w-4'
														onChange={handleFilters}
														/* onChange={
																handleInvNotesFilter
															} */
													/>
													<span
														className={`text-[#004A80] font-medium transition-all duration-200`}>
														Status fora do prazo
													</span>
												</label>

												{/* <button
													id='data_notificacao'
													className='flex items-center text-[14px] font-normal gap-[8px] justify-between hover:text-[#4aa7dd]'
													onClick={(e) =>
														filteChange(e)
													}>
													Data
													<FaSortAlphaDown
														id='data_notificacao'
														onClick={(e) => {
															filteChange(e);
															setInvFilter(false);
														}}
													/>
												</button> */}
												{currentUser.card ===
												'NOTIFICADO' ? null : currentUser.card ===
														'CLASSIFICADO' &&
												  currentUser.status ===
														'CLASSIFICADO' ? (
													<label
														htmlFor='minhas-investigacoes'
														className='flex items-center text-[14px] font-normal  gap-2  cursor-pointer'>
														<input
															type='checkbox'
															id='minhas-investigacoes'
															className='accent-[#757575] text-[#1e2e58] border-[1px]  rounded-full h-4 w-4'
															onChange={
																handleFilters
															}
															/* onChange={
																handleInvNotesFilter
															} */
														/>
														<span className='text-[#004A80] font-medium'>
															Minhas investigações
														</span>
													</label>
												) : null}

												{(currentUser.card ===
													'INVESTIGADO') &
												(currentUser.status ===
													'NOTIFICADO') ? (
													<label
														htmlFor='pendentes'
														className='flex items-center text-[14px] font-normal  gap-2  cursor-pointer'>
														<input
															type='checkbox'
															id='pendentes'
															className='accent-[#757575] text-[#1e2e58] border-[1px]  rounded-full h-4 w-4'
															onChange={
																handleFilters
															}
															/* onChange={
																handleInvNotesFilter
															} */
														/>
														<span className='text-[#004A80] font-medium'>
															Notificações
															pendentes
														</span>
													</label>
												) : null}
												{/* {(currentUser.card ===
													'INVESTIGADO') &
												(currentUser.status ===
													'NOTIFICADO') ? (
													<button
														className='flex items-center text-[14px] font-normal gap-[8px] justify-between hover:text-[#4aa7dd]'
														onClick={() =>
															handleAvalNotesFilter(
																'CONCLUIDO'
															)
														}>
														Concluídas
														<FaSortAlphaDown
															onClick={() =>
																handleAvalNotesFilter(
																	'CONCLUIDO'
																)
															}
														/>
													</button>
												) : null} */}
											</div>
											{/* <div className='w-full sm:w-auto flex flex-wrap justify-end gap-4 px-4 py-2 font-inter text-sm text-[#8a8a8a] font-medium bg-white rounded-md '>
												<div className='flex items-center sm:justify-normal justify-between min-w-[90px] gap-1'>
													<input
														type='checkbox'
														name='status'
														id='atrasados'
														onChange={handleFilters}
														className='peer hidden'
													/>
													<label
														htmlFor='atrasados'
														className='cursor-pointer bg-white border-[1px] border-[#a8a8a8] flex items-center  rounded-full h-4 w-4  
														peer-checked:bg-[#6ec3ff]
														peer-checked:border-0
														  transition text-4xl
														 text-[#ffffff]
														 peer-checked:text-[#ffffff] 
														 '>
														<FaCheck className='scale-75' />
													</label>
													atrasados
												</div>
												<div className='flex  sm:justify-normal items-center justify-between min-w-[90px] gap-1'>
													<input
														type='checkbox'
														onChange={handleFilters}
														name='status'
														id='atribuidos'
														className='peer hidden'
													/>
													<label
														htmlFor='atribuidos'
														className='cursor-pointer bg-white border-[1px] border-[#a8a8a8] flex items-center  rounded-full h-4 w-4  
														peer-checked:bg-[#6ec3ff]
														peer-checked:border-0
														  transition text-4xl
														 text-[#ffffff]
														 peer-checked:text-[#ffffff] 
														 '>
														<FaCheck className='scale-75' />
													</label>
													atribuidos
												</div>
												<div className='flex items-center sm:justify-normal justify-between min-w-[90px] gap-1'>
													<input
														type='checkbox'
														onChange={handleFilters}
														name='status'
														id='no prazo'
														className='peer hidden'
													/>
													<label
														htmlFor='no prazo'
														className='cursor-pointer bg-white border-[1px] border-[#a8a8a8] flex items-center  rounded-full h-4 w-4  
														peer-checked:bg-[#6ec3ff]
														peer-checked:border-0
														  transition text-4xl
														 text-[#ffffff]
														 peer-checked:text-[#ffffff] 
														 '>
														<FaCheck className='scale-75' />
													</label>
													no prazo
												</div>
											</div> */}
										</div>
									</div>

									{(currentFilter.length === 0 &&
										invFilter === true) ||
									currentFilter ===
										'Nenhuma notificação encontrada' ||
									itemsPerPage.length === 0 ? (
										<div className='flex justify-center font-inter font-bold text-[12px] sm:text-xl text-[#bbbbbb] py-10'>
											Nenhuma notificação encontrada...
										</div>
									) : !listLoading ? (
										<div className='flex-col w-full px-[22px] pr-[28px]'>
											{itemsPerPage.map(
												(notificacao, index) => (
													<div
														key={index}
														className='w-full'>
														<div className=' w-full flex justify-between'>
															<div className='h-full my-auto mr-[10px] xl:mr-0'>
																{/* {console.log(
																	allNotes?.find(
																		(
																			item
																		) =>
																			item.protocolo ===
																			notificacao?.protocolo
																	)
																		?.quem_presenciou
																)} */}
																<button
																	onClick={() => {
																		goToClassification(
																			currentUser.status,
																			currentUser.card,
																			`${currentUser.status}-${currentUser.card}` ===
																				'CLASSIFICADO-CLASSIFICADO'
																				? {
																						...notificacao?.notificacao,
																						unidade_nome:
																							notificacao?.unidade_nome,
																						protocolo:
																							notificacao?.protocolo,
																						status: notificacao?.status,
																						quem_presenciou:
																							notificacao?.quem_presenciou
																								? notificacao?.quem_presenciou
																								: allNotes?.find(
																										(
																											item
																										) =>
																											item.protocolo ===
																											notificacao?.protocolo
																								  )
																										?.quem_presenciou,
																						permissao:
																							JSON.parse(
																								Cookies.get(
																									'user'
																								)
																							).cargo.includes(
																								'desenvolvedor'
																							) ||
																							JSON.parse(
																								Cookies.get(
																									'user'
																								)
																							).cargo.includes(
																								'gestor'
																							)
																								? true
																								: notificacao?.investigadores
																										?.map(
																											(
																												i
																											) =>
																												i.nome
																										)
																										.join(
																											', '
																										)
																										.includes(
																											JSON.parse(
																												Cookies.get(
																													'user'
																												)
																											)
																												.nome
																										),
																				  }
																				: {
																						...notificacao,
																						permissao: true,
																				  }
																		);
																	}}
																	className='bg-white  border-[2px] px-[10px] py-[8px] rounded-md text-[#004A80] gap-[10px] font-semibold flex border-[#004A80]  hover:text-white align-text-middle hover:bg-[#004A80] transition-all duration-200'>
																	{' '}
																	<div className='[8px]'>
																		{(() => {
																			const key = `${currentUser.status}-${currentUser.card}`;
																			// Exceção para 'NOTIFICADO-INVESTIGADO' quando notificacao?.status for 'CONCLUIDO'
																			const user =
																				JSON.parse(
																					Cookies.get(
																						'user'
																					)
																				);
																			if (
																				(user.unidade.includes(
																					'subhue'
																				) ||
																					user.cargo.includes(
																						'gestor'
																					) ||
																					user.cargo.includes(
																						'usuario'
																					)) &&
																				currentUser.status ===
																					''
																			) {
																				return (
																					<IoMdEye className='scale-[130%]' />
																				);
																			}

																			if (
																				key ===
																					'CLASSIFICADO-CLASSIFICADO' &&
																				!notificacao?.investigadores
																					?.map(
																						(
																							item
																						) =>
																							item.nome
																					)
																					.includes(
																						user.nome
																					) &&
																				user.cargo !==
																					'gestor' &&
																				user.cargo !==
																					'desenvolvedor'
																			) {
																				return (
																					<IoMdEye className='scale-[130%]' />
																				);
																			}

																			if (
																				key ===
																					'NOTIFICADO-INVESTIGADO' &&
																				notificacao?.status ===
																					'CONCLUIDO'
																			) {
																				return (
																					<IoMdEye className='scale-[130%]' />
																				);
																			}
																			return (
																				{
																					'NOTIFICADO-CLASSIFICADO':
																						(
																							<IoMdEye className='scale-[130%]' />
																						),
																					'NOTIFICADO-NOTIFICADO':
																						(
																							<HiOutlinePencilSquare className='scale-[180%]' />
																						),
																					'NOTIFICADO-INVESTIGADO':
																						(
																							<LuClipboardCheck className='scale-[180%]' />
																						),
																					'CLASSIFICADO-NOTIFICADO':
																						(
																							<IoMdEye className='scale-[130%]' />
																						),
																					'CLASSIFICADO-INVESTIGADO':
																						(
																							<IoMdEye className='scale-[130%]' />
																						),
																					'CLASSIFICADO-CLASSIFICADO':
																						(
																							<FaSearch className='scale-[120%]' />
																						),
																					'INVESTIGADO-NOTIFICADO':
																						(
																							<IoMdEye className='scale-[130%]' />
																						),
																					'INVESTIGADO-CLASSIFICADO':
																						(
																							<IoMdEye className='scale-[130%]' />
																						),
																					'INVESTIGADO-INVESTIGADO':
																						(
																							<LuClipboardCheck className='scale-[180%]' />
																						),
																				}[
																					key
																				] ||
																				null
																			);
																		})()}
																	</div>
																	<p className='my-auto text-[12px]  hidden sm:block '>
																		{(() => {
																			const key = `${currentUser.status}-${currentUser.card}`;

																			const user =
																				JSON.parse(
																					Cookies.get(
																						'user'
																					)
																				);

																			if (
																				key ===
																					'CLASSIFICADO-CLASSIFICADO' &&
																				!notificacao?.investigadores
																					?.map(
																						(
																							item
																						) =>
																							item.nome
																					)
																					.includes(
																						user.nome
																					) &&
																				user.cargo !==
																					'gestor' &&
																				user.cargo !==
																					'desenvolvedor'
																			) {
																				return 'Visualizar';
																			}

																			if (
																				key ===
																					'NOTIFICADO-INVESTIGADO' &&
																				notificacao?.status ===
																					'CONCLUIDO'
																			) {
																				return 'Visualizar';
																			}

																			if (
																				(user.unidade.includes(
																					'subhue'
																				) ||
																					user.cargo ===
																						'gestor' ||
																					user.cargo ===
																						'usuario') &&
																				currentUser.status ===
																					''
																			) {
																				return 'Visualizar';
																			}

																			return (
																				{
																					'NOTIFICADO-CLASSIFICADO':
																						'Visualizar',
																					'CLASSIFICADO-CLASSIFICADO':
																						'Investigar',
																					'NOTIFICADO-NOTIFICADO':
																						'Classificar',
																					'NOTIFICADO-INVESTIGADO':
																						'Avaliar',
																					'CLASSIFICADO-NOTIFICADO':
																						'Visualizar',
																					'CLASSIFICADO-INVESTIGADO':
																						'Visualizar',
																					'INVESTIGADO-NOTIFICADO':
																						'Visualizar',
																					'INVESTIGADO-CLASSIFICADO':
																						'Visualizar',
																				}[
																					key
																				] ||
																				null
																			);
																		})()}
																	</p>
																</button>
															</div>

															<div className='flex gap-[14px] overflow-x-auto '>
																<div className=' flex flex-col justify-center text-center gap-[12px]'>
																	<p className='text-[#757575] text-[14px] font-normal'>
																		{' '}
																		Notificação
																	</p>
																	<p className='text-[#004A80] text-[16px] font-normal'>
																		{' '}
																		{
																			notificacao.protocolo
																		}
																	</p>
																</div>
																<div className=' h-[100%] content-center'>
																	<div className='w-[1px]  h-[45px]  bg-[#E3E3E3] '></div>
																</div>
																<div className=' flex flex-col text-center justify-center gap-[12px]'>
																	<p className='text-[#757575] text-[14px] font-normal'>
																		{' '}
																		Data da
																		ocorrência
																	</p>
																	<p className='text-[#004A80] text-[16px] font-normal'>
																		{' '}
																		{notificacao?.data_ocorrencia
																			? notificacao?.data_ocorrencia
																					.split(
																						'-'
																					)
																					.reverse()
																					.join(
																						'/'
																					)
																			: notificacao?.notificacao.data_ocorrencia
																					.split(
																						'-'
																					)
																					.reverse()
																					.join(
																						'/'
																					)}
																	</p>
																</div>

																<div className=' h-[100%] content-center '>
																	<div className='w-[1px] h-[45px] my-[20%] bg-[#E3E3E3] '></div>
																</div>
																<div className=' flex flex-col justify-center text-center gap-[12px]'>
																	<p className='text-[#757575] text-[14px] font-normal'>
																		{' '}
																		Incidente
																	</p>
																	<p className='text-[#004A80] max-w-[171px] sm:min-w-[171px] leading-[19.2px]  text-[16px] font-normal'>
																		{' '}
																		{notificacao?.tipo_incidente ===
																			'OUTROS' ||
																		notificacao
																			?.notificacao
																			?.tipo_incidente ===
																			'OUTROS'
																			? 'Outros'
																			: notificacao?.tipo_incidente ===
																					'' ||
																			  notificacao
																					?.notificacao
																					?.tipo_incidente ===
																					''
																			? 'Não consta'
																			: findValueFromDisplay(
																					notificacao.tipo_incidente
																						? notificacao.tipo_incidente
																						: notificacao
																								?.notificacao
																								.tipo_incidente
																			  )}
																	</p>
																</div>
																<div className=' h-[100%] content-center '>
																	<div className='w-[1px] h-[45px] my-[20%] bg-[#E3E3E3] '></div>
																</div>
																<div className=' flex flex-col text-center justify-center w-[110px] gap-[12px]'>
																	<p className='text-[#757575] text-[14px] font-normal '>
																		{' '}
																		Envolve
																		paciente
																	</p>
																	<p className='text-[#004A80] max-w-[130px] leading-[19.2px] text-[16px] font-normal break-words'>
																		{' '}
																		{notificacao?.nome_paciente
																			? notificacao?.nome_paciente !==
																			  ''
																				? 'Sim'
																				: 'Não'
																			: notificacao
																					?.notificacao
																					?.envolve_paciente
																			? 'Sim'
																			: 'Não'}
																	</p>
																</div>
																<div className=' h-[100%] content-center'>
																	<div className='w-[1px] h-[45px] my-[20%] bg-[#E3E3E3] '></div>
																</div>
																<div className='max-w-[170px] sm:min-w-[100px] flex flex-col text-center justify-center gap-[12px]'>
																	<p className='text-[#757575] text-[14px] font-normal'>
																		{' '}
																		{currentUser.card ===
																		'NOTIFICADO'
																			? 'Turno'
																			: currentUser.card ===
																					'CLASSIFICADO' &&
																			  currentUser.status ===
																					'CLASSIFICADO'
																			? 'Investigadores Designados'
																			: 'Turno'}
																	</p>
																	<p
																		className='text-[#004A80] text-[16px] font-normal'
																		title={
																			notificacao?.investigadores
																				?.map(
																					(
																						i
																					) =>
																						i.nome
																				)
																				.join(
																					', '
																				) ||
																			'Nenhum Atribuído'
																		}>
																		{currentUser.card ===
																			'CLASSIFICADO' &&
																		currentUser.status ===
																			'CLASSIFICADO'
																			? notificacao
																					?.investigadores
																					?.length ===
																			  0
																				? 'Nenhum Atribuído'
																				: notificacao
																						?.investigadores
																						?.length >
																				  1
																				? `${notificacao.investigadores[0].nome}...`
																				: notificacao
																						?.investigadores?.[0]
																						?.nome ||
																				  ''
																			: notificacao
																					?.notificacao
																					?.turno_display
																			? notificacao
																					?.notificacao
																					?.turno_display
																			: notificacao?.turno
																			? notificacao?.turno_display
																			: notificacao
																					?.notificacao
																					?.turno_display}
																	</p>
																</div>
																<div className=' h-[100%] content-center'>
																	<div className='w-[1px] h-[45px] my-[20%] bg-[#E3E3E3]'></div>
																</div>
																<div className='flex flex-col text-center justify-center gap-[12px] min-w-[110px]'>
																	<p className='text-[#757575] text-[14px] font-normal'>
																		{' '}
																		Status
																	</p>

																	<div
																		className={`px-[8px] rounded-full justify-center flex gap-2 py-[2px] ${
																			{
																				pendente:
																					'bg-[#FFE4E3] text-[#B74644]',
																				'em atraso':
																					'bg-[#FFE4E3] text-[#B74644]',
																				'no prazo':
																					'bg-[#E3F2FF] text-[#2A6BBF]',
																				concluido:
																					'bg-[#E4FFE3] text-[#44B746]',
																			}[
																				notificacao?.status ===
																				'CONCLUIDO'
																					? 'concluido'
																					: notificacao?.status ===
																							'CLASSIFICADO' ||
																					  notificacao?.status ===
																							'REINVESTIGACAO'
																					? notificacao
																							?.protocolo_info
																							?.atraso ===
																					  true
																						? 'em atraso'
																						: 'no prazo'
																					: 'no prazo'
																			]
																		}`}>
																		<div className='flex gap-2 '>
																			<div className='items-center content-center'>
																				<GoDotFill />
																			</div>
																			<p className='content-center flex items-center'>
																				{/* 	{console.log(
																				notificacao,
																				notes[
																					index
																				]
																			)} */}
																				{notificacao?.status ===
																				'CONCLUIDO'
																					? 'concluido'
																					: notificacao?.status ===
																							'CLASSIFICADO' ||
																					  notificacao?.status ===
																							'REINVESTIGACAO'
																					? notificacao
																							?.protocolo_info
																							?.atraso ===
																					  true
																						? 'em atraso'
																						: 'no prazo'
																					: 'no prazo'}
																			</p>
																		</div>
																	</div>
																</div>
															</div>
														</div>
														<div className='bg-[#dadada] h-[1px] w-full my-[32px]'></div>
													</div>
												)
											)}
										</div>
									) : (
										<Loading />
									)}
									{itemsPerPage.length > 0 && (
										<div className='flex justify-center scale-[50%] sm:scale-[80%] gap-[10px] my-[20px]'>
											{Array.from(
												{
													length: Math.ceil(
														(currentFilter.length >
															0 &&
														currentFilter !==
															'Nenhuma notificação encontrada'
															? currentFilter
															: notes
														).length / 10
													),
												},
												(_, index) => {
													const pageNum = index + 1;
													const isActive =
														currentPage === pageNum;

													return (
														<button
															key={pageNum}
															onClick={
																handlePaginate
															}
															id={pageNum.toString()}
															className={`w-[28px] h-[28px] transition-all duration-300 ${
																isActive
																	? 'bg-[#1d456b]'
																	: 'bg-[#1c5d9b]'
															} hover:bg-[#1d456b] items-center align-middle rounded-full content-center font-semibold text-[#ffffff]`}>
															{pageNum}
														</button>
													);
												}
											)}
										</div>
									)}
								</div>
							</div>
						</div>
					)}
				</div>
			)}
			<Footer />
		</div>
	);
}

export default NotesAvaliation;
